<template>
  <div
    class="vue-notification-template notification-broadcast"
    :class="[item.type, item.data.avatar_url ? 'has-avatar' : '', item.data.url ? 'clickable' : '']"
  >
    <div
      class="notification-avatar avatar-single avatar-single--circle avatar-single--small"
      v-if="item.data && item.data.avatar_url"
      :style="{'background-image':'url(' + item.data.avatar_url + ')'}"
    >
    </div>
    <div
      v-if="item.title"
      class="notification-title"
      v-html="item.title"
    >
    </div>
    <div class="notification-content" v-html="item.text"></div>
    <div class="notification-blank-link" :class="[item.type, item.data.avatar_url ? 'has-avatar' : '', item.data.url ? 'clickable' : '']" @click="actionClick"></div>
    <button class="button button__icon" @click="emitClose"><i class="demo-icon icon-close"></i></button>

  </div>
</template>
<script>

export default {
  name: 'NotificationPopup',
  components: {},
  props: {
    item: {
      required: true,
    },
  },
  data() {
    return {};
  },
  computed: {},
  watch: {},
  methods: {
    actionClick() {
      if (this.item.data.url) {
        window.location.href = this.item.data.url;
      }
      this.emitClose();
    },
    emitClose() {
      this.$emit('close');
    }
  },
};
</script>
